import { useEffect, useRef } from 'react'
import { useAnalytics } from './AnalyticsProvider'
import { trackedSurfaceIdentity } from './contentIdentity'

// Module-level, survives unmount/remount within the page session. Only used to
// collapse the near-instant re-emit when a surface's subtree is remounted (the
// analytics widget panels remount 1-2x while the id/scope settles in the URL).
// A real revisit happens seconds later and is NOT suppressed.
const lastEmittedAt = new Map()

export default function useTrackedSurface(event, { active = true, contentId, content, parent, dedupeMs = 0 } = {}) {
    const { trackEvent } = useAnalytics()
    const previousIdentityRef = useRef(null)

    useEffect(() => {
        if (!active || !event?.name) {
            previousIdentityRef.current = null
            return
        }
        const identity = trackedSurfaceIdentity(event.name, contentId, content)
        if (previousIdentityRef.current === identity) return
        if (dedupeMs > 0 && Date.now() - (lastEmittedAt.get(identity) || 0) < dedupeMs) return
        previousIdentityRef.current = identity
        if (dedupeMs > 0) lastEmittedAt.set(identity, Date.now())
        trackEvent(event, { contentId, content, parent })
    }, [active, content, contentId, event, parent, dedupeMs, trackEvent])
}
